const DEFAULT_REGION = 'us-west-2';

export function fmtS3ConsoleLink(s3BucketAndPrefix, region=DEFAULT_REGION) {
    if(s3BucketAndPrefix.startsWith("s3://")) {
      s3BucketAndPrefix=s3BucketAndPrefix.slice(5);
    }
    return `https://s3.console.aws.amazon.com/s3/buckets/${s3BucketAndPrefix}?region=${region}&tab=overview`;
}

export function fmtStackFilterLink(stackName, region=DEFAULT_REGION) {
  return `https://${region}.console.aws.amazon.com/cloudformation/home?region=${region}#/stacks?filteringText=${stackName}&filteringStatus=active&viewNested=true&hideStacks=false&stackId=`;
}

export function fmtDashboardLink(dashboardName, region=DEFAULT_REGION) {
  return `https://${region}.console.aws.amazon.com/cloudwatch/home?region=${region}#dashboards:name=${dashboardName}`;
}

export function fmtECRConsoleLink(account, repo, region=DEFAULT_REGION) {
  return `https://${region}.console.aws.amazon.com/ecr/repositories/private/${account}/${repo}?region=${region}`;
}

export function fmtAthenaPreviewTableLink(database, table, region=DEFAULT_REGION) {
  return `https://${region}.console.aws.amazon.com/athena/home?region=${region}&catalog=AwsDataCatalog&database=${database}#/preview/${database}/${table}`;
}